import { Controller } from "@hotwired/stimulus"
import {init_global_js} from "../packs/global"
import {init_bootstrap} from "../packs/global_bootstrap"

export default class extends Controller {

  connect() {
    // console.log("Hello, Global activation!", this.element);

    init_global_js(this.element);
    init_bootstrap(this.element);
  }
}
